import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "drafts__wrapper"
}

import { t } from '@nextcloud/l10n'
import { computed } from 'vue'
import NcButton from '@nextcloud/vue/components/NcButton'
import NcDialog from '@nextcloud/vue/components/NcDialog'
import NcLoadingIcon from '@nextcloud/vue/components/NcLoadingIcon'
import IconPoll from 'vue-material-design-icons/Poll.vue'
import EmptyView from '../EmptyView.vue'
import PollCard from '../MessagesList/MessagesGroup/Message/MessagePart/PollCard.vue'
import { EventBus } from '../../services/EventBus.ts'
import { usePollsStore } from '../../stores/polls.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'PollDraftHandler',
  props: {
    token: {},
    editorOpened: { type: Boolean },
    container: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const pollsStore = usePollsStore()
/**
 * Receive poll drafts for the current conversation as owner/moderator
 */
pollsStore.getPollDrafts(props.token)
const pollDrafts = computed(() => pollsStore.getDrafts(props.token))
const pollDraftsLoaded = computed(() => pollsStore.draftsLoaded(props.token))

/**
 * Opens poll editor pre-filled from the draft
 *
 * @param payload method payload
 * @param payload.id poll draft ID
 * @param payload.action required action ('fill' from draft or 'edit' draft)
 */
function openPollEditor({ id, action }: { id: number | null, action?: string }) {
	EventBus.emit('poll-editor-open', { token: props.token, id, fromDrafts: !props.editorOpened, action, selector: props.container })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcDialog), {
    class: "drafts",
    name: _unref(t)('spreed', 'Poll drafts'),
    container: __props.container,
    size: "normal",
    "close-on-click-outside": "",
    "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, _createSlots({
    default: _withCtx(() => [
      (!pollDrafts.value.length)
        ? (_openBlock(), _createBlock(EmptyView, {
            key: 0,
            class: "drafts__empty",
            name: pollDraftsLoaded.value ? _unref(t)('spreed', 'No poll drafts') : _unref(t)('spreed', 'Loading …'),
            description: pollDraftsLoaded.value ? _unref(t)('spreed', 'There is no poll drafts yet saved for this conversation') : ''
          }, {
            icon: _withCtx(() => [
              (pollDraftsLoaded.value)
                ? (_openBlock(), _createBlock(IconPoll, { key: 0 }))
                : (_openBlock(), _createBlock(_unref(NcLoadingIcon), { key: 1 }))
            ]),
            _: 1
          }, 8, ["name", "description"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pollDrafts.value, (item) => {
              return (_openBlock(), _createBlock(PollCard, {
                id: item.id.toString(),
                key: item.id,
                token: __props.token,
                name: item.question,
                draft: "",
                onClick: openPollEditor
              }, null, 8, ["id", "token", "name"]))
            }), 128))
          ]))
    ]),
    _: 2
  }, [
    (!props.editorOpened)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _createVNode(_unref(NcButton), {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openPollEditor({ id: null, action: 'fill' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('spreed', 'Create new poll')), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["name", "container"]))
}
}

})